<template>
  <div class="bg-change-password">
    <div class="container-fluid">
        <div style="display:flex; justify-content:center; align-items:center; height: 80vh;">
          <div class="forgot-page">
            <div class="panel panel-default">
              <div class="text-center">
                <!-- <div style="text-align: center;">
                  <img v-if="!forConasi" class="my-4" width="250px" src="../../assets/e_voucher_logo.svg">
                  <img v-else class="my-4" width="250px" src="../../assets/e_voucher_logo.png">
                </div> -->
                <div class="line-header">
                </div>
                <div class="panel-body">
                  <form class="form" ref="form">
                    <div class="title-form">
                      {{ $t('common.changePassword') }}
                    </div>
                    <fieldset>
                      <div class="form-group">
                        <div class="input-group">
                          <label for="inputFullname">{{ $t('register.oldPassword') }}</label>
                          <div class="input-content">
                            <input
                              id="inputFullname"
                              class="form-control"
                              oninvalid="this.setCustomValidity('Bạn chưa điền mật khẩu')"
                              oninput="setCustomValidity('')"
                              :type="passwordFieldTypeNew"
                              required=""
                              v-model="oldPassword"
                              @keyup.enter="onConfirmResetPassword($event)"
                            >
                            <!-- <div class="btn-show-hiden-password" @click="switchVisibility(1)">
                              <span class="fa fa-fw fa-eye field-icon toggle-password" v-if="passwordFieldTypeNew == 'password'"></span>
                            </div> -->
                          </div>
                        </div>
                        <div class="input-group">
                          <label for="inputFullname">{{ $t('register.newPassword') }}</label>
                          <div class="input-content">
                            <input
                              id="inputFullname"
                              class="form-control"
                              oninvalid="this.setCustomValidity('Bạn chưa điền mật khẩu')"
                              oninput="setCustomValidity('')"
                              :type="passwordFieldTypeNew"
                              required=""
                              v-model="newPassword"
                              @keyup.enter="onConfirmResetPassword($event)"
                            >
                            <!-- <div class="btn-show-hiden-password" @click="switchVisibility(1)">
                              <span class="fa fa-fw fa-eye field-icon toggle-password" v-if="passwordFieldTypeNew == 'password'"></span>
                            </div> -->
                          </div>
                        </div>
                        <div class="input-group" style="margin-top:10px;">
                          <label for="inputFullname">{{ $t('register.confirmPassword') }}</label>
                          <div class="input-content">
                            <input
                              id="emailInput"
                              class="form-control"
                              oninvalid="this.setCustomValidity('Bạn chưa xác nhận lại mật khẩu')"
                              oninput="setCustomValidity('')"
                              :type="passwordFieldTypeConfirm"
                              required=""
                              v-model="confirmNewPassword"
                              @keyup.enter="onConfirmResetPassword($event)"
                            >
                            <!-- <div class="btn-show-hiden-password" @click="switchVisibility(2)">
                              <span class="fa fa-fw fa-eye field-icon toggle-password"></span>
                            </div> -->
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <!-- <input class="btn btn-lg btn-outline-success btn-block" value="Xác nhận" type="submit" @click="onConfirmResetPassword($event)"> -->
                        <button type="submit" class="btn btn-primary" @click="onConfirmResetPassword($event)">{{ $t('common.changePassword') }}</button>
                      </div>
                    </fieldset>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import functionUtils from "Utils/functionUtils";
import { FOR_CONASI_TARGET } from 'Utils/constants'

export default {
  data() {
    return {
      passwordFieldTypeNew: 'password',
      passwordFieldTypeConfirm: 'password',
      newPassword: null,
      oldPassword: null,
      confirmNewPassword: null,
      changeIncon: false,
      InconHidePassword: true,
      forConasi: FOR_CONASI_TARGET
    }
  },
  methods: {
    /**
     * Valid require
     */
    validRequire: function(fieldRequire) {
      if (fieldRequire != "" && fieldRequire != null) {
        return true;
      } else {
        return false;
      }
    },
    // SwitchVisibility

    // switchVisibility(nub) {
    //   if (nub === 1) {
    //     this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    //   } else {
    //     this.passwordFieldTypeConfirm = this.passwordFieldTypeConfirm === 'password' ? 'text' : 'password'
    //   }
    // },

    // Require value

    // requiredValue (value) {
    //   if (value !== null && value !== undefined && value.length !== 0) {
    //     return true
    //   }
    //   return this.$t('common.requiredFields')
    // },

    // Validate old and new password
    // sameValue (newPassword, confirmNewPassword) {
    //   if ((newPassword != null && confirmNewPassword != null) && newPassword !== confirmNewPassword) {
    //     return this.$t('register.passwordIncorrect')
    //   }
    //   return true
    // },

    validatePassword(newPassword, confirmNewPassword) {
      if ((newPassword != null && confirmNewPassword != null) && newPassword !== confirmNewPassword) { return false }
      // const re = /^(?=.{5,})(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W])/;
      return true
    },

    // Validate
    validate () {
      if (this.validatePassword(this.newPassword, this.confirmNewPassword)) {
        let filter = {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          confirmPassword: this.confirmNewPassword,
          email: sessionStorage.getItem('Email')
        }
        this.isLoading = true
        this.CONFIRM_CHANGE_PASSWORD(filter).then(
          function () {
            this.isLoading = false
            this.$toast.clear()
            this.$toast.success(this.$t('common.notificationToast.success'), {
            position: "bottom-left",
            timeout: 1500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
          });
          this.oldPassword = null
          this.newPassword = null
          this.confirmPassword = null
          }.bind(this)
        ).catch(
          function (error) {
            if (!functionUtils.isNull(error.response.data.message)) {
              let errorText = error.response.data.message
              this.$toast.clear()
              this.$toast.error(this.$t(errorText), {
                position: "bottom-left",
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false
              });
            } else {
              this.$toast.clear()
              this.$toast.error(this.$t('login.somethingWentWrong'), {
                position: "bottom-left",
                timeout: 1500,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: false,
                closeButton: "button",
                icon: true,
                rtl: false
              });
            }
          }.bind(this)
        )
      }
    },

    onConfirmResetPassword: function (event) {
      event.preventDefault()
      if (this.validRequire(this.newPassword)) {
        if (this.validRequire(this.confirmNewPassword)) {
          if (this.newPassword == this.confirmNewPassword) {
            this.validate()
          } else {
              this.$toast.clear()
              this.$toast.error(this.$t('common.notificationToast.passwordIncorrect'), {
              position: "bottom-left",
              timeout: 1500,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: false,
              closeButton: "button",
              icon: true,
              rtl: false
            });
          }
        } else {
            this.$toast.clear()
            this.$toast.error(this.$t('common.notificationToast.pleaseConfirmYourNewPassword'), {
            position: "bottom-left",
            timeout: 1500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }
      } else {
          this.$toast.clear()
          this.$toast.error(this.$t('common.notificationToast.pleaseEnterANewPassword'), {
          position: "bottom-left",
          timeout: 1500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: true,
          rtl: false
        });
      }
    },
    ...mapActions(['CONFIRM_CHANGE_PASSWORD'])
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/color.scss";
.bg-change-password {
  background-color: $bg-primary;
}
.forgot-page {
  width: 33vw;
  height: auto;
  .container-fluid {
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 100vh;

    opacity:0;
    -webkit-animation:container ease-in 1;
    -moz-animation:container ease-in 1;
    animation:container ease-in 1;

    -webkit-animation-fill-mode:forwards;
    -moz-animation-fill-mode:forwards;
    animation-fill-mode:forwards;

    -webkit-animation-duration:1s;
    -moz-animation-duration:1s;
    animation-duration:1s;

  }

  .line-header {
    border-top: 1px solid #eee;
    transform: translate(0px, 4rem);
  }

  .panel-body {
    background-color: #F7FAFC;
    font-family: Roboto;
    border-radius: 5px;
    padding: 0 38px 83px 38px;
    box-shadow: 0 0px 17px 0 rgba(0, 0, 0, 0.1);

    .title-form {
      font-size: 18px;
      font-weight: 600;
      padding: 21px 0px 40px 0px;
      text-align: center;
      text-transform: uppercase;
      color: $primary;
    }
    .form-group {
      .input-group {
        display: flex;
        align-items: center;
      
        .input-group-addon {
          width: 10%;
          font-size: 25px;
          padding: 0px 8px;
          background-color: #eee;
          color: #666;
          border-radius: 5px 0 0 5px;
        }

        label {
          color: $primary;
          font-size: 14px;
        }

        .input-content {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 5px;

          input {
            height: 30px;
            color: $primary !important;
            box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
            border: none;
            font-size: 14px;
            margin-bottom: 1rem;

            &:focus {
              box-shadow: none;
              border: 1px solid $primary !important;
              outline: none;
            }
          }

          .btn-show-hiden-password {

            svg {
              margin-right: 10px;
              color: #999;
              font-size: 15px;
              cursor: pointer;
            }
          }
        }
      }

      button {
        width: 100%;
        font-weight: 600;
        background-color: $primary;
        border: none;
        padding: 8px 0;
        margin-top: 15px;

        &:hover {
          background-color: #a55f4a;
        }

        &:focus {
          box-shadow: none;
        }

        &:active {
          background-color: $primary;
        }
      }
    }

    ::-webkit-input-placeholder { /* Edge */
      font-size: 14px;
      color: $primary;
    }

    :-ms-input-placeholder { /* Internet Explorer */
      font-size: 14px;
      color: $primary;
    }

    ::placeholder {
      font-size: 14px;
      color: $primary;
    }

    input, select, textarea{
      color: $primary;

    }
  }
}
@media only screen and (max-width: 1200px) {
    .forgot-page {
      width: 70vw;
    }
    .image-responsive {
      width: 200px !important;
    }
  }

  @media only screen and (max-width: 769px) {
    .forgot-page {
      width: 90vw;
    }
    .image-responsive {
      width: 180px !important;
    }
  }
</style>